export const getters = {
    getEstoque: state => state.estoque,
    getEstoques: state => state.estoques,
    getModalCadastroEstoque: state => state.modalCadastroEstoque,
    getModalImprimirEstoque: state => state.modalImprimirEstoque,
    getModalExcluirEstoque: state => state.modalExcluirEstoque,
    getModalMovimentacaoEstoque: state => state.modalMovimentacaoEstoque,
    getListarEstoque: state => state.listarEstoque
}

export default {}